import React from 'react'
import { Video } from '@yy/one-icon'
import { OneButton } from '@yy/one-ui'
import { useTranslation } from '../../../hooks'
import styles from './index.module.less'

const RecordButton: React.FC<React.ComponentProps<typeof OneButton>> = (props) => {
  const { t } = useTranslation()

  return (
    <OneButton {...props} type="dashed" className={styles.button}>
      <Video />
      {t('feedback.start')}
    </OneButton>
  )
}

export default RecordButton
